const Icons = ( props ) => {
	return (<i className={`icon-${ props.name } icon--sgb`}></i>)
}

export default Icons
